import { useEffect } from "react"

/**
 * Muestra u oculta un elemento del DOM según un flag booleano.
 * @param {boolean} visible  - Si true el elemento se muestra, si false se oculta.
 * @param {string}  elementId - ID del elemento a controlar.
 */
const useToggleVisibility = (visible, elementId) => {
    useEffect(() => {
        const el = document.getElementById(elementId)
        if (el) el.style.display = visible ? "block" : "none"
    }, [visible, elementId])
}

export default useToggleVisibility
